import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DtoSchoolUser } from '../../../../models/school.model';
import { HttpErrorResponse } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../../../../shared/components/confirm/confirm.component';
import { MatDialogCloseEvent, DocumentType } from '../../../../const';
import { SchoolService } from '../../../school/school.service';
import { Role, RolePayload } from '../../../../models/role.model';
import { EditUserRoleComponent } from '../../user-role/edit-user-role/edit-user-role.component';
import { ProdetailsModalComponent } from '../../../data-management/prodetails-modal/prodetails-modal.component';
import { AddSchoolUserComponent } from '../../../school/add-school-user/add-school-user.component';
import { AccountAdminCenterService } from '../../../account-admin-center/account-admin-center.service';
import { ConfirmDialogComponent } from '../../../mat-account/confirm-dialog/confirm-dialog.component';
import { MatAccountService } from '../../../mat-account/mat-account.service';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { DtoPreviewItem } from '../../../../models/package-center.model';
import { SharedService } from '../../../../shared/services/shared.service';

export enum RoleMaster { SuperAdmin = "1", AccountAdmin = "2", MatAdmin = "3", SchoolAdmin = "4"}

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html'
})
export class UserDetailsComponent implements OnInit {
  @Output() resetCreateTrigger = new EventEmitter<void>();
  @Output() actionEmitter = new EventEmitter<{}>();
  @Input() schoolUserList : DtoSchoolUser[] = [];
  @Input() showSchoolUser : boolean = false;
  @Input() openedFromIndividualSchool: boolean = false;
  @Input() roles: Role[] = []
  @Input() clientAccountId: number = 0;
  @Input() viewMode: boolean = false;
  @Input() schoolId: number = 0;
  @Input() createTriggered: boolean = false;
  @Input() packageId: number = 0;
  @Input() numberOfUsersToAllow: number = 0;
  @Input() isSchoolUser : boolean = false;
  @Input() searchTriggered: boolean = false;
  @Input() searchTerm: string = "";
  @Input() independentSchoolId: number = 0;
   
  userRole: string[] = [];
  rolesMaster = RoleMaster;
  roleName: string[] = [];
  userEmail: string = "";
  actionTypes = ActionType;
  filteredSchoolUsers: DtoSchoolUser[] = [];
  firstName: boolean = false;
  lastName: boolean = false;
  emailId: boolean = false;
  countryCode: boolean = false;
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  schoolAdminExists: boolean = false;

  constructor(private toasterService: ToastrService, private dialog: MatDialog,
              private accountAdminCenterService: AccountAdminCenterService, 
              private sharedService: SharedService,
              private schoolService: SchoolService, 
              private matAccountService: MatAccountService
  ){}

  ngOnInit(): void {
    this.getClaims()
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(RoleMaster, element)!);
    });

    if(this.userRole.includes(RoleMaster.SchoolAdmin) || this.schoolId > 0){
      this.getSchoolUsers(this.userEmail, this.schoolId);
      this.openedFromIndividualSchool = true;
      if(this.userRole.includes(RoleMaster.SchoolAdmin)){
        this.viewMode = true;
        return;
      }
    }

    this.getRoles(this.clientAccountId);
  }

  
  getClaims() {
    const decodedToken = this.sharedService.getLoginToken();

    // Access role claim
    if(decodedToken?.orgType==='ORG'){
      this.schoolId = parseInt(decodedToken?.orgId);
      this.clientAccountId = decodedToken?.clientAccountId==null?0:parseInt(decodedToken?.clientAccountId);
    }
  }

  filterUsers() {
    if(!this.searchTerm){
      this.filteredSchoolUsers = [...this.schoolUserList];
      this.schoolAdminExists = this.schoolUserList.some(user =>
        user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
      );
    }
    else{
      this.filteredSchoolUsers = this.schoolUserList.filter(user =>
        user.firstName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.lastName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.emailId?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.countryCode?.toString().toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
  }

  getRoles(clientAccountId: number, schoolId: number = 0){
    let id = schoolId > 0 ? schoolId : this.schoolId
    let payload = {
      isIndividualEntity : clientAccountId == 0,
      clientAccountId : clientAccountId > 0 ? [clientAccountId] : [id]
    } as RolePayload;
    this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>{
      this.roles = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.createTriggered) {
      if(this.numberOfUsersToAllow <= this.schoolUserList.length){ //Including School Admin
        this.toasterService.error("Maximum number of school users for this school has already been created");
        this.resetCreateTrigger.emit();
        return;
      }
      this.schoolService.getSchoolUsers(this.userEmail, this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
        this.schoolUserList = response;
        this.filteredSchoolUsers = [...this.schoolUserList];

        this.schoolAdminExists = this.schoolUserList.some(user =>
          user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
        );

        this.openCreateSchoolUserDialog();
      },(err: HttpErrorResponse)=>{
        if(err.error){
          this.toasterService.error(err.error, "Error");
        }
      })
    }
    if(changes['schoolUserList']?.currentValue){
      this.filteredSchoolUsers = [...this.schoolUserList];
      for(const schoolUser of this.schoolUserList){
        if(!schoolUser.countryCode){
          let countryCode = this.phoneNumberUtil.parse(schoolUser.contactNumber?.toString()).getCountryCode()!;
          let nationalNumber = this.phoneNumberUtil.parse(schoolUser.contactNumber?.toString()).getNationalNumber()!;
  
          schoolUser.countryCode = countryCode;
          schoolUser.phoneNumber = nationalNumber;
        }
      }
    }
    if(changes['searchTriggered']?.currentValue){
      if(this.showSchoolUser){
        this.filterUsers();
        this.resetCreateTrigger.emit();
      }
      return;
    }
    else{
      this.filterUsers();
    }
  }

  previewPopup(roleDetails: Role[]){
    this.dialog.open(ProdetailsModalComponent,{
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: {
        singleItemPreview: true,
        itemToPreview: (roleDetails.map(role=>({
          groupName: null,
          itemName: role.roleName
        })) as DtoPreviewItem[]),
        title: 'Added Roles'
      }
    })
  }
  
  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }
  
  getSchoolUsers(email: string, schoolId: number = 0){
    this.schoolService.getSchoolUsers(email, schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
      this.schoolUserList = response;
      this.filteredSchoolUsers = [...this.schoolUserList];
      this.schoolId = this.schoolId <= 0 ? this.schoolUserList[0].schoolId : this.schoolId;
      this.schoolAdminExists = this.schoolUserList.some(user =>
        user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
      );
      if(this.userRole.includes(RoleMaster.SchoolAdmin)){
        this.getRoles(this.clientAccountId);
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  activateDeactivateSchoolUser(schoolUser: DtoSchoolUser){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: schoolUser.isActive,
        message: "Are you sure want to" + (schoolUser.isActive ? " inactivate" : " activate") + " the school user?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.schoolService.updateUserStatus(schoolUser.userId).subscribe((res)=>{
          if(res){
            this.toasterService.success("School User" + (schoolUser.isActive ? " activated" : " inactivated") + " successfully","Success");
          }
        },(error: HttpErrorResponse)=>{
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
          schoolUser.isActive = !schoolUser.isActive;
        })
      }
      else{
        schoolUser.isActive = !schoolUser.isActive;
      }
    });
  }

  async openCreateSchoolUserDialog(userDetail: DtoSchoolUser = {} as DtoSchoolUser): Promise<any>{

    //Opened upon Create School User from Individual School
    let numberOfUsers = 0;
    if(!userDetail.schoolUserId){
      try {
        numberOfUsers = await this.matAccountService.allowCreateSchoolUser(this.schoolId);
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        this.resetCreateTrigger.emit();
        return;
      }
    }
    userDetail.contactNumber = userDetail.phoneNumber;
    let roles = this.roles.filter(x=>x.isActive);
    //if(!this.schoolAdminExists)
    if (!roles.some(r => r.roleId === Number(RoleMaster.SchoolAdmin)))
    {
      roles = [{
        roleId: Number(RoleMaster.SchoolAdmin),
        roleName: 'School Admin'
      } as Role, ...roles];
    }

    this.dialog.open(AddSchoolUserComponent, {
      width: '1000px',
      data: {
        userDetail: userDetail.schoolUserId ? userDetail : {}, 
        assignedPackageId: this.packageId,
        roles: roles,
        schoolId: this.schoolId,
        clientAccountId: this.clientAccountId,
        allowBulkUpload: true,
        availableNumberOfSchoolUsersToCreate: numberOfUsers
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        if(popupEvent.data.isBulkUploaded){
          setTimeout(()=>{
            this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
              this.schoolUserList = response;
              this.filteredSchoolUsers = [...this.schoolUserList];

              this.schoolAdminExists = this.schoolUserList.some(user =>
                user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
              );
            },(err: HttpErrorResponse)=>{
              if(err.error){
                this.toasterService.error(err.error, "Error");
              }
            })
            this.resetCreateTrigger.emit();
          }, 1000)
          return;
        }
        popupEvent.data.userDetails.schoolId = this.schoolId;
        this.schoolService.createSchoolUser([popupEvent.data.userDetails]).subscribe((response: any)=>{
          if(response.isSuccess){
            this.toasterService.success("User details created successfully", "Success");
            this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
              this.schoolUserList = response;
              this.filteredSchoolUsers = [...this.schoolUserList];

              this.schoolAdminExists = this.schoolUserList.some(user =>
                user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
              );

              if (popupEvent.data.fileData && popupEvent.data.fileData.has('file')) {
                const user = this.schoolUserList.find(user => user.emailId === popupEvent.data.userDetails.emailId);
                if(user){
                  this.uploadDocument(popupEvent.data.fileData, DocumentType.EntityAudience, user.userId.toString());
                }
              }
            },(err: HttpErrorResponse)=>{
              if(err.error){
                this.toasterService.error(err.error, "Error");
              }
            })
          }
        },(err: HttpErrorResponse)=>{
          if(err.error){
            this.toasterService.error(err.error, "Error");
          }
        })
      }
      this.getRoles(this.clientAccountId);
      this.resetCreateTrigger.emit();
    });
  }

  openEditRolePopup(role: Role, schoolUser: DtoSchoolUser){
    this.dialog.open(EditUserRoleComponent, {
      width: '1000px',
      data: {
        role: role,
        editUserDetail: this.isRoleSharedWithUser(schoolUser, role),
        clientAccountId: this.clientAccountId,
        packageId: this.packageId,
        schoolId: this.schoolId
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        let indexToReplace = schoolUser.role.findIndex(x => x.roleId == role.roleId);
        schoolUser.role[indexToReplace] = popupEvent.data;
        if(this.isRoleSharedWithUser(schoolUser, role)){
          schoolUser.role[indexToReplace].isModified = true
        }
      }
    });
  }

  editUser(schoolUser: DtoSchoolUser, i: number): void {
    if(this.openedFromIndividualSchool){
      this.openEditSchoolUser(schoolUser)
    }
    else{
      this.actionEmitter.emit({action: this.actionTypes.EditSchoolUser, index: i})
    }
  }

  sortSchoolUsers(sortDirection: string, sortColumn: keyof DtoSchoolUser) {
    const isAsc = sortDirection === 'asc';
  
    this.filteredSchoolUsers = this.filteredSchoolUsers.sort((a, b) => {
      const valueA = a[sortColumn];
      const valueB = b[sortColumn];
  
      if (valueA == null || valueB == null) {
        return 0; // Handle null or undefined values
      }
  
      // Handle string comparison
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return isAsc
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }
  
      // Handle number comparison
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return isAsc ? valueA - valueB : valueB - valueA;
      }
  
      // Handle date comparison (assuming valueA and valueB are dates)
      if (valueA instanceof Date && valueB instanceof Date) {
        return isAsc
          ? valueA.getTime() - valueB.getTime()
          : valueB.getTime() - valueA.getTime();
      }
  
      return 0; // Default case if types don't match
    });
  }

  deleteUser(schoolUser: DtoSchoolUser, i: number) {
    if (this.openedFromIndividualSchool) {
      this.openDeleteSchoolUser(i)
    }
    else {
      this.actionEmitter.emit({ action: this.actionTypes.DeleteSchoolUser, index: i })
    }
  }

  checkIfRoleExists(role: Role, schoolUser: DtoSchoolUser): boolean {
    return this.schoolUserList.every(user => user.role.some(roleValue => roleValue.roleId === role.roleId));
  }

  isRoleSharedWithUser(targetUser: DtoSchoolUser, newRole: Role): boolean {
    for (let user of this.filteredSchoolUsers) {
        if (user !== targetUser) {
            for (let role of user.role) {
                if (newRole.roleName == role.roleName) {
                    return true;
                }
            }
        }
    }

    return false;
}

  onRoleChange(value: Role[], schoolUser: DtoSchoolUser, index: number){
    const userIndex = this.filteredSchoolUsers.findIndex((user: DtoSchoolUser) => user.emailId === schoolUser.emailId);
    
    const schoolAdmin = this.roles.find(role => role.roleId == Number(RoleMaster.SchoolAdmin));
    // Check if School Admin is selected
    const isSchoolAdminSelected = value.some(role => role.roleId === schoolAdmin?.roleId);
    var roleList = [schoolAdmin!];
    if(isSchoolAdminSelected  && value.length > 1){
      this.toasterService.warning("Other roles cannot be added, when School Admin role is selected!");
      
      this.filteredSchoolUsers[userIndex].role = roleList;
    }
    else{
      roleList = this.roles.filter((role: Role) => {
        return value.some((userRole: Role) => role.roleId === userRole.roleId);
      });
      this.filteredSchoolUsers[userIndex].role = [];
      this.filteredSchoolUsers[userIndex].role = roleList;
    }
    
    
    //Set this value in SchoolDetailForm to make this change globally available 
    this.actionEmitter.emit({action: this.actionTypes.UpdateRole, index: index, role: roleList})
  }

  openEditSchoolUser(userDetail: DtoSchoolUser = {} as DtoSchoolUser){
    //Opened from Edit School User
    if(userDetail.role?.length && userDetail.role?.length == 1 && userDetail.role[0].roleName == "SchoolAdmin"){
      userDetail.isAdmin = true;
    }
    userDetail.contactNumber = userDetail.phoneNumber;
    this.dialog.open(AddSchoolUserComponent, {
      width: '1000px',
      data: {
        userDetail: userDetail.schoolUserId ? userDetail : {},
        assignedPackageId: this.packageId,
        roles: this.roles.filter(x=>x.isActive == true),
        schoolId: this.schoolId,
        clientAccountId: this.clientAccountId,
        allowBulkUpload: false
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        if(userDetail.userId > 0){
          popupEvent.data.userDetails.userId = userDetail.userId;
          popupEvent.data.userDetails.isAdmin = userDetail.isAdmin;
          this.schoolService.updateSchoolUser(popupEvent.data.userDetails).subscribe((response: any)=>{
            if(response){
              this.toasterService.success("School user details updated successfully","Success");
              if (popupEvent.data.fileData && popupEvent.data.fileData.has('file')) {
                this.uploadDocument(popupEvent.data.fileData, DocumentType.EntityAudience, userDetail.userId.toString());
              }

              this.getSchoolUsers(this.userEmail, this.schoolId);
            }
          },(err: HttpErrorResponse)=>{
            if(err.error){
              this.toasterService.error(err.error, "Error");
            }
          });
        }
      }
      this.getRoles(this.clientAccountId);
      this.resetCreateTrigger.emit();
    });
  }

  openDeleteSchoolUser(userIndex: number){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the school user?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        let schoolUser = this.filteredSchoolUsers[userIndex];
        if(schoolUser.userId > 0){
          this.accountAdminCenterService.deleteUser(schoolUser.userId.toString()).subscribe((response: any)=>{
            if (response) {
              this.toasterService.success('User details deleted successfully', 'Success');
              this.getSchoolUsers(this.userEmail, this.schoolId);
            }
          }, (errorResponse: HttpErrorResponse) => {
            if(errorResponse.error){
              this.toasterService.error(errorResponse.error, "Error");
            }
          })
        }
      }
    });
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }

  ViewDocument(data: DtoSchoolUser){
    if(!data?.document?.length){
      this.toasterService.warning("No attachment found");
      return;
    }
    this.dialog.open(ConfirmDialogComponent, {
      width: '675px',
      data: {
        hideUpload: true,
        files: data.document // Pass files to the dialog
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.doc){
        data.document = popupEvent.doc;
      }
    });
  }

}

export enum ActionType { CreateAnotherUser = "create", BulkUpload = "bulkUpload", EditSchoolUser = "edit", DeleteSchoolUser = "delete", UpdateRole = "updateRole" }